import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import { enableES5 } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/context/SettingsContext';
import { configureStore } from 'src/store';
import { restoreSettings } from 'src/utils/settings';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import App from 'src/App';
import firebase from "firebase";

// Use your config values here.
firebase.initializeApp({
  apiKey: "AIzaSyC0Va4q7LJjm689yIYxjyriJjcsozBls1A",
  authDomain: "fz-smartvial-municipios.firebaseapp.com",
  databaseURL: "https://fz-smartvial-municipios.firebaseio.com",
  projectId: "fz-smartvial-municipios",
  storageBucket: "fz-smartvial-municipios.appspot.com",
  messagingSenderId: "984285794781",
  appId: "1:984285794781:web:2e396472faa6ed969a2634"
});
//firebase
firebase.analytics();

enableES5();

const store = configureStore();
const settings = restoreSettings();
/*Para acceder al store: $r.props.store.getState()*/
/*Test Branch*/
ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <SettingsProvider settings={settings}>
        <App />
      </SettingsProvider>
    </I18nextProvider>
  </Provider>
  ,
  document.getElementById('root')
);

serviceWorker.unregister();
